import { createSelector } from '@ngrx/store';
import { ActionObjectType } from '@shared/models/sync/action-object-type';
import { selectClientNames } from '../../clients/clients.selectors';
import { SyncDisplayResolver } from '../models/sync-display-resolver';
import { SyncDisplaySlices } from '../models/sync-display-slices';
import { SyncProducer } from '../models/sync-producer';
import { videoUploadsProducer } from './video-uploads/video-uploads.producer';

// The single extension point. Adding a synced object type = one producer here — the sync selector,
// the resolver signature and the sync-center UI stay untouched.
const syncProducers: SyncProducer[] = [videoUploadsProducer];

// Strategy registry keyed by parent ActionObjectType. A group whose parent type is absent here is
// skipped by the selector.
export const syncDisplayResolvers: Partial<Record<ActionObjectType, SyncDisplayResolver>> = Object.fromEntries(
  syncProducers.map((producer) => [producer.type, producer.resolver]),
);

// The read-time slices every resolver receives: clientNames is common (every item shows its client),
// each producer merges in the slice its own resolver needs. Composed from the registry, so a new
// producer's slice flows through without editing the selector.
export const selectSyncDisplaySlices = createSelector(
  [selectClientNames, ...syncProducers.map((producer) => producer.selectSlices)],
  (clientNames, ...sliceParts): SyncDisplaySlices => Object.assign({ clientNames }, ...sliceParts),
);
